<div class="flex justify-between items-center min-h-[37px]">
  @let unknownText = 'common.unknown' | translate;
  @let displayName =
    (PermissionStoreModelEnum.ViewAnySites | hasPermission) && !vm().hideTenantName
      ? (vm().siteTenant || unknownText) + ' - ' + vm().siteName
      : vm().siteName;
  <span class="font-medium">{{ displayName }}</span>

  <a [routerLink]="[RouteSegment.Root, RouteSegment.Sites, vm().siteId]" class="flex items-center">
    <app-table-view-link />
  </a>
</div>
@if (vm().isLoadingDetails) {
  <app-site-at-a-glance-loading-skeleton />
} @else {
  <app-site-at-a-glance [vm]="atAGlanceVm()" />
}
